import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { FONTS } from '../../constants/config';
import { CalendarEvent, EVENT_CATEGORY_COLORS } from './types';

interface EventCardProps {
  event: CalendarEvent;
  height: number;
  onPress?: (event: CalendarEvent) => void;
}

export default function EventCard({ event, height, onPress }: EventCardProps) {
  // Use custom color if provided (from activity identity_color), otherwise fall back to category
  const baseConfig = EVENT_CATEGORY_COLORS[event.category] || { bg: '#ff7f0e', border: '#ff7f0e', text: '#FFFFFF', variant: 'solid' as const };
  const colorConfig = event.color
    ? { bg: event.color, border: event.color, text: '#FFFFFF', variant: 'solid' as const }
    : baseConfig;
  const isSolid = colorConfig.variant === 'solid';
  const showMeta = isSolid && height >= 60;

  return (
    <TouchableOpacity
      activeOpacity={0.85}
      onPress={() => onPress?.(event)}
      style={[
        styles.container,
        {
          backgroundColor: colorConfig.bg,
          borderRightWidth: 4,
          borderRightColor: colorConfig.border,
          height,
        },
      ]}
      accessibilityRole="button"
      accessibilityLabel={`${event.title}, ${event.startTime} - ${event.endTime}`}
    >
      <Text
        style={[styles.title, { color: colorConfig.text }]}
        numberOfLines={2}
      >
        {event.title}
      </Text>

      {showMeta && (
        <View style={styles.meta}>
          <View style={styles.metaRow}>
            <Ionicons name="time-outline" size={11} color="rgba(255,255,255,0.85)" />
            <Text style={styles.metaText} numberOfLines={1}>
              {event.startTime} - {event.endTime}
            </Text>
          </View>
          {event.participantCount != null && (
            <View style={styles.metaRow}>
              <Ionicons name="people-outline" size={11} color="rgba(255,255,255,0.85)" />
              <Text style={styles.metaText} numberOfLines={1}>
                {event.participantCount} مشاركين
              </Text>
            </View>
          )}
        </View>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    overflow: 'hidden',
    justifyContent: 'center',
  },
  title: {
    fontSize: 12,
    fontFamily: FONTS.regular,
    lineHeight: 14,
    textAlign: 'right',
  },
  meta: {
    marginTop: 3,
    gap: 3,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  metaText: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: 10,
    fontFamily: FONTS.regular,
    lineHeight: 14,
  },
});
